import {DOCUMENT, Location, PlatformLocation} from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  Renderer2, TemplateRef,
  ViewChild
} from '@angular/core';
import {Router} from '@angular/router';
import {infoPlayer} from '@app/app/pdp/pdp-model';
import {PlayerService} from '@app/components/player/player.service';
import {DeviceService, HttpService} from '@app/core';
import {IndicatorService} from '@app/shared';
import {NotificationService} from '@app/shared/notification/notification.service';
import {environment} from '@env/environment';
import {animate, state, style, transition, trigger} from "@angular/animations";
import {WishlistService} from "@app/app/wishlist/wishlist.service";
import {NavigationBarService} from "@app/shared/navigation-bar/navigation-bar.service";
import {delay} from "rxjs/operators";
import {of} from "rxjs";
import {ISubscriptionStatus} from "@app/app/library/iModelSummary";
import {NavigationBarEnum} from "@app/shared/navigation-bar/navigation-bar.model";
import {ClientTypeEnum} from "@app/helper/ClientTypeEnum";
import {AppParametersService} from "@app/core/token/app-parameters.service";

const navigator = window.navigator as any;


@Component({
  selector: 'navaar-context-menu-library',
  templateUrl: './context-menu-library.component.html',
  styleUrls: ['./context-menu-library.component.scss'],
  animations: [
    trigger('slide', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(150)
      ]),
      transition(':leave',
        animate(150, style({opacity: 0})))
    ])
  ]
})
export class ContextMenuLibraryComponent implements OnInit {
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if (this.isShow) {
      this.isShow = false;
    }
  }

  @ViewChild('end_subscription', {read: TemplateRef, static: true}) private endSubscription: TemplateRef<any>;
  @ViewChild('menu_item', {read: TemplateRef, static: true}) private menuITemTemp: TemplateRef<any>;
  @ViewChild('remove_dialog_bookmark', {
    read: TemplateRef,
    static: true
  }) private removeDialogBookmarkTemp: TemplateRef<any>;
  @ViewChild('remove_dialog_library', {
    read: TemplateRef,
    static: true
  }) private removeDialogLibraryTemp: TemplateRef<any>;

  @Output() private OnClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() private onRefresh: EventEmitter<void> = new EventEmitter<void>();

  @Input('subscription-status') public subscriptionStatus: ISubscriptionStatus;
  @Input() public identifier: number;
  @Input() public isOwner: boolean | null;
  @Input() public audiobookId: string;
  @Input() public audiobookTitle: string;
  @Input() public tab: 'bookmark' | 'library' | 'search';

  @Input() set isShow(e: boolean) {
    this._isShow = e;
    if (e === false) {
      this.identifier = null;
      this.audiobookId = null;
      this.audiobookTitle = null;
      this.subscriptionStatus = null;
      this.render.removeStyle(this.document.body, 'overflow');
      this.typeOfTemp = this.menuITemTemp;
      this.OnClose.emit();
    } else if (e) {
      this.slideAnimationPopup = 'void';
      this.render.setStyle(this.document.body, 'overflow', 'hidden');
      this.platformLocation.pushState(null, null, this.location.path() + '#modalOpened');
    }
  }

  get isShow(): boolean {
    return this._isShow;
  }

  private _isShow: boolean;
  public slideAnimationPopup: string;
  public typeOfTemp: TemplateRef<any>;
  public isDisable: boolean = false;
  public clientTypeEnum: typeof ClientTypeEnum = ClientTypeEnum;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    public readonly parameterService: AppParametersService,
    private readonly platformLocation: PlatformLocation,
    private readonly location: Location,
    private readonly render: Renderer2,
    private readonly notificationService: NotificationService,
    private readonly http: HttpService,
    private readonly playService: PlayerService,
    private readonly indicatorService: IndicatorService,
    private readonly router: Router,
    private readonly device: DeviceService,
    private readonly navigationBarService: NavigationBarService) {
  }

  ngOnInit(): void {
    this.typeOfTemp = this.menuITemTemp;
  }

  public play() {
    if (this.tab === 'bookmark') {
      if (this.isOwner === false) {
        this.RouteToPdp();
        return;
      }
    }
    if (this.tab === 'library') {
      if (this.subscriptionStatus != null && (this.subscriptionStatus.isSubscriptionConsumption && this.subscriptionStatus.isExpired)) {
        this.typeOfTemp = this.endSubscription;
        return;
      }
    }
    this.http.post(`/api/library/info/${this.identifier}`).subscribe(z => {
      const infoPlayer: infoPlayer = {
        audioBookId: z.audioBookId,
        title: z.title,
        image: `${environment.imageUrl}/content/books/${z.audioBookId}/pic.jpg?t=${z.recordVersion}`,
        isOwner: z.isOwner,
        identifier: z.identifier,
        contentType: z.contentType,
        author: z.authors[0] ? z.authors[0].firstName + ' ' + z.authors[0].lastName : '',
        narrators: z.narrators[0] ? z.narrators[0].firstName + ' ' + z.narrators[0].lastName : '',
        productId: z.productId
      }
      this.playService.initial(infoPlayer);
      this.isShow = false;
    });
  }

  public RouteToPdp() {
    this.indicatorService.show();
    const _i = this.identifier;
    this.location.back();
    of(true).pipe(delay(150)).subscribe(x => this.router.navigate(['pdp', _i]).then(() => this.navigationBarService.activeMenu = NavigationBarEnum.vitrin));
  }

  public share() {
    this.device.share(this.identifier, this.audiobookTitle);
  }

  public remove() {
    if (this.tab === 'library') {
      this.typeOfTemp = this.removeDialogLibraryTemp;
    } else if (this.tab === 'bookmark') {
      this.typeOfTemp = this.removeDialogBookmarkTemp;
    }
  }

  public onSlidePopupAnimation(event: AnimationEvent) {
    if (this.isShow === false)
      if (this.location.path(true).includes('#modalOpened'))
        this.location.back();
  }

  public removeBookmark() {
    this.isDisable = true;
    this.http.post('/api/wishlist/remove', {audiobookId: this.audiobookId}).subscribe(z => {
      this.notificationService.setNotification({
        show: true,
        text: 'کتاب از نشان شده ها حذف شد',
        type: 'info'
      });
      this.onRefresh.emit();
      this.isShow = false;
      this.isDisable = false;
    }, () => {
      this.isDisable = false;
      this.notificationService.setNotification({
        show: true,
        text: 'در عملیات خطا رخ داده است',
        type: 'error'
      })
    })
  }

  public removeLibrary() {
    this.isDisable = true;
    let url: string;
    if (this.subscriptionStatus.isSubscriptionConsumption === false)
      url = `/api/library/archive/${this.audiobookId}`;
    else if (this.subscriptionStatus.isSubscriptionConsumption === true)
      url = `/api/library/remove/${this.audiobookId}`;
    else
      return;
    this.http.post(url).subscribe(z => {
      this.notificationService.setNotification({
        show: true,
        text: 'کتاب از لیست حذف شد',
        type: 'info'
      });
      this.onRefresh.emit();
      this.isShow = false;
      this.isDisable = false;
    }, () => {
      this.isDisable = false;
      this.notificationService.setNotification({
        show: true,
        text: 'در عملیات خطا رخ داده است',
        type: 'error'
      })
    })
  }

  public cancel() {
    this.isShow = false;
  }

  public goToSubscription() {
    this.cancel();
    of(true).pipe(delay(350)).subscribe(x =>
      this.router.navigate(['./subscription', 'plans']).then(z => this.navigationBarService.prepareNavigationBar()))
  }
}
